import React from 'react'
import Highcharts from 'highcharts'
import HighchartsReact from 'highcharts-react-official'

import { useTheme } from '@mui/material/styles'

import { getSeriesColor } from '../../utils/graphUtils'
import { ProfileEditorSeries } from '../../types/profileEditorSeries'

interface ProfileLibraryCardChartProps {
  series?: ProfileEditorSeries
}

const ProfileLibraryCardChart = (props: ProfileLibraryCardChartProps): JSX.Element => {
  const theme = useTheme()

  const chartOptions = {
    title: { text: '' },
    exporting: false,
    credits: { enabled: false },
    accessibility: { enabled: false },
    chart: {
      width: 150,
      height: 150,
      backgroundColor: 'transparent',
    },
    legend: {
      enabled: false,
    },
    plotOptions: {
      series: {
        marker: {
          enabled: true,
        },
        enableMouseTracking: false,
      },
    },
    yAxis: [
      {
        visible: false,
      },
    ],
    xAxis: [
      {
        visible: false,
      },
    ],
    series: props.series
      ? [
          {
            type: 'spline',
            animation: false,
            color: getSeriesColor(props.series.param, theme),
            data: props.series.data.map((x) => {
              return {
                x: x.msec,
                y: x.dataValue,
              }
            }),
          },
        ]
      : [],
  }

  return <HighchartsReact highcharts={Highcharts} options={chartOptions} />
}

export default ProfileLibraryCardChart
